var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormInputContainer',{staticClass:"FormStripeCard",attrs:{"inputId":("I" + _vm._uid),"label":_vm.label}},[_c('div',{ref:"cardMount"})])}
var staticRenderFns = []

export { render, staticRenderFns }